import { render, staticRenderFns } from "./SidebarReference.vue?vue&type=template&id=5f773de2&"
import script from "./SidebarReference.vue?vue&type=script&lang=js&"
export * from "./SidebarReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports